/* 
 * Export component file to be used on project
*/

import ProfileSpecialities from './ProfileSpecialities.js';
export default ProfileSpecialities;
